import styled from "styled-components";

export const DynamicTextValidationErrorsContainer = styled.div`
    padding: 8px 16px;
    margin-top: 8px;
`;

export const DynamicTextValidationErrorsGroup = styled.div`
    & + & {
        margin-top: 8px;
    }
`;

export const DynamicTextValidationErrorsList = styled.ul`
    padding-left: 24px;
    margin: 16px;
    line-height: 20px;
    list-style: disc;
`;